import { useContext } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from 'pages/Login'
import Home from 'pages/Home'
import PurchaseOrderReceiving from 'pages/PurchaseOrderReceiving'
import SalesOrderPicking from 'pages/SalesOrder/SalesOrderPicking'
import OrderContextProvider from 'contexts/OrderContextProvider'
import { AuthContext } from 'contexts/AuthContextProvider'
import ChooseOperation from 'pages/ChooseOperation'
import TransferOrder from 'pages/TransferOrder'
import UserContextProvider from 'contexts/UserContextProvider'
import UserList from 'pages/User/UserList'
import UserActions from 'pages/UserActions'
import UpdateOrderCache from 'pages/SalesOrder/UpdateOrderCache'
import TransferOrderFBAPrint from 'pages/TransferOrder/TransferOrderFBAPrint'
import SingleItemOrder from 'pages/DailyOrder/SingleItemOrder'
import AddOrUpdateDailyOrder from 'pages/DailyOrder/AddOrUpdateDailyOrder'
import MultipleItemOrder from 'pages/DailyOrder/MultipleItemOrder'
import SpecialOrder from 'pages/DailyOrder/SpecialOrder'
import BoxOperations from 'pages/DailyOrder/BoxOrder/BoxOperations'
import PickItemToBox from 'pages/DailyOrder/BoxOrder/PickItemToBox'
import BoxOrderContextProvider from 'contexts/BoxOrderContextProvider'
import BoxCodeOrderPicking from 'pages/DailyOrder/BoxOrder/BoxCodeOrderPicking'
import BoxList from 'pages/DailyOrder/BoxOrder/BoxList'
import BoxDetail from 'pages/DailyOrder/BoxOrder/BoxDetail'
import OrderCancellation from 'pages/DailyOrder/OrderCancellation'
import DailyOrderSelect from 'pages/DailyOrder'
import ManageDailyOrder from 'pages/DailyOrder/ManageDailyOrder'
import SyncDailyOrder from 'pages/DailyOrder/SyncDailyOrder'
import DailyOrderList from 'pages/DailyOrder/DailyOrderList'
import DailyOrderDetail from 'pages/DailyOrder/DailyOrderDetail'
import DailyOrderPicking from 'pages/DailyOrder/DailyOrderPicking'
import SyncOrderHistory from 'pages/DailyOrder/SyncOrderHistory'
import SalesOrder from 'pages/SalesOrder'
import TransferOrderPicking from 'pages/TransferOrder/TransferOrderPicking'
import ItemLookup from 'pages/ItemLookup'
import DailyOrderSearch from 'pages/DailyOrder/DailyOrderSearch'
import UpdateTransferOrderCache from 'pages/TransferOrder/UpdateTransferOrderCache'

const AppRouter = () => {
  const { isAuthorized } = useContext(AuthContext)

  return (
    <OrderContextProvider>
      <Routes>
        <Route path='/login' element={<Login />} />
        {isAuthorized ? (
          <>
            <Route path='/' element={<Home />} />
            <Route
              path='/:company/*'
              element={
                <Routes>
                  <Route path='/' element={<ChooseOperation />} />
                  <Route
                    path='/sales-order/*'
                    element={
                      <Routes>
                        <Route path='/' element={<SalesOrder />} />
                        <Route
                          path='/sales-order-picking'
                          element={<SalesOrderPicking />}
                        />
                        <Route
                          path='/update-order-cache'
                          element={<UpdateOrderCache />}
                        />
                      </Routes>
                    }
                  />
                  <Route
                    path='/transfer-order/*'
                    element={
                      <Routes>
                        <Route path='/' element={<TransferOrder />} />
                        <Route
                          path='/transfer-order-picking'
                          element={<TransferOrderPicking />}
                        />
                        <Route
                          path='/transfer-order-fba-print'
                          element={<TransferOrderFBAPrint />}
                        />
                        <Route
                          path='/update-transfer-order-cache'
                          element={<UpdateTransferOrderCache />}
                        />
                      </Routes>
                    }
                  />
                  <Route
                    path='/daily-order/*'
                    element={
                      <Routes>
                        <Route
                          path='/manage-daily-order'
                          element={<ManageDailyOrder />}
                        />
                        <Route
                          path='/add-or-update-daily-order'
                          element={<AddOrUpdateDailyOrder />}
                        />
                        <Route
                          path='/single-item-order'
                          element={<SingleItemOrder />}
                        />
                        <Route
                          path='/multiple-item-order-without-box'
                          element={<MultipleItemOrder />}
                        />
                        <Route
                          path='/special-order'
                          element={<SpecialOrder />}
                        />
                        <Route path='/search' element={<DailyOrderSearch />} />
                        <Route
                          path='/sync-daily-order'
                          element={<SyncDailyOrder />}
                        />
                        <Route
                          path='/sync-order-history'
                          element={<SyncOrderHistory />}
                        />
                        <Route
                          path='/daily-order-list'
                          element={<DailyOrderList />}
                        />
                        <Route
                          path='/daily-order-list/:orderId'
                          element={<DailyOrderDetail />}
                        />
                        <Route
                          path='/order-cancellation'
                          element={<OrderCancellation />}
                        />
                        <Route
                          path='/box-code-order/*'
                          element={
                            <BoxOrderContextProvider>
                              <Routes>
                                <Route path='/' element={<BoxOperations />} />
                                <Route
                                  path='/pick-item-to-box'
                                  element={<PickItemToBox />}
                                />
                                <Route
                                  path='/fulfill-order'
                                  element={<BoxCodeOrderPicking />}
                                />
                                <Route
                                  path='/fulfill-order/:orderNumber'
                                  element={<DailyOrderPicking />}
                                />
                              </Routes>
                            </BoxOrderContextProvider>
                          }
                        />
                        <Route
                          path='/box/*'
                          element={
                            <BoxOrderContextProvider>
                              <Routes>
                                <Route path='/box-list' element={<BoxList />} />
                                <Route
                                  path='/box-list/:boxId'
                                  element={<BoxDetail />}
                                />
                              </Routes>
                            </BoxOrderContextProvider>
                          }
                        />
                        <Route
                          path='/:orderNumber'
                          element={<DailyOrderPicking />}
                        />
                        <Route path='/' element={<DailyOrderSelect />} />
                      </Routes>
                    }
                  />
                  <Route
                    path='/purchase-order-receiving'
                    element={<PurchaseOrderReceiving />}
                  />
                  <Route path='/item-lookup' element={<ItemLookup />} />
                </Routes>
              }
            />

            <Route
              path='/users/*'
              element={
                <UserContextProvider>
                  <Routes>
                    <Route path='*' element={<UserList />} />
                  </Routes>
                </UserContextProvider>
              }
            />
            <Route path='/user-actions' element={<UserActions />} />
          </>
        ) : (
          <Route path='*' element={<Navigate to='/login' replace />} />
        )}
      </Routes>
    </OrderContextProvider>
  )
}

export default AppRouter
